/**
 * Konfiguration des Standorts Nürnberg.
 *
 * Diese Seite hat nur noch einen Standort. Veitsbronn läuft seit dem
 * 02.10.2026 unter 22studiosveitsbronn.de und ist von hier vollständig
 * getrennt — keine Routen, keine Links, keine Standortweiche.
 */

export const NUERNBERG_CONTACT = {
  street: "Deidesheimer Str. 4",
  postalCode: "90469",
  city: "Nürnberg",
  phone: "0151 7253 0302",
  phoneTel: "+4915172530302",
  email: "info@22studios.de",
  region: "Bayern",
  planityUrl: "https://www.planity.com/de-DE/22-studios-90469-nurnberg",
  lat: 49.4204,
  lng: 11.0878,
} as const;

export const PLANITY_URL = NUERNBERG_CONTACT.planityUrl;

export function getLocationContact() {
  return NUERNBERG_CONTACT;
}

export function getPlanityUrl() {
  return PLANITY_URL;
}

export type OpeningHoursEntry = {
  label: string;
  time: string;
};

export const NUERNBERG_OPENING_HOURS: OpeningHoursEntry[] = [
  { label: "Mo", time: "Geschlossen" },
  { label: "Di – Mi", time: "09:00 – 18:00" },
  { label: "Do – Fr", time: "10:00 – 20:00" },
  { label: "Sa", time: "09:00 – 16:00" },
  { label: "So", time: "Geschlossen" },
];

export function getOpeningHours(): OpeningHoursEntry[] {
  return NUERNBERG_OPENING_HOURS;
}

export const NUERNBERG_OPENING_HOURS_SCHEMA = [
  { "@type": "OpeningHoursSpecification", dayOfWeek: "Tuesday", opens: "09:00", closes: "18:00" },
  { "@type": "OpeningHoursSpecification", dayOfWeek: "Wednesday", opens: "09:00", closes: "18:00" },
  { "@type": "OpeningHoursSpecification", dayOfWeek: "Thursday", opens: "10:00", closes: "20:00" },
  { "@type": "OpeningHoursSpecification", dayOfWeek: "Friday", opens: "10:00", closes: "20:00" },
  { "@type": "OpeningHoursSpecification", dayOfWeek: "Saturday", opens: "09:00", closes: "16:00" },
] as const;

export function getOpeningHoursSchema() {
  return NUERNBERG_OPENING_HOURS_SCHEMA;
}
